// src/components/settings/SettingsSidebar.js
import React from 'react';
import {
    Cog6ToothIcon,
    StarIcon,
    LinkIcon,
    UsersIcon,
    CreditCardIcon,
    ShieldCheckIcon,
} from '@heroicons/react/24/outline';

const SettingsSidebar = ({ activeSection, setActiveSection }) => {
    const navItems = [
        { id: 'general', label: 'General', icon: Cog6ToothIcon },
        { id: 'loyaltyProgram', label: 'Loyalty Program', icon: StarIcon },
        { id: 'integrations', label: 'Integrations', icon: LinkIcon },
        { id: 'users', label: 'Users & Roles', icon: UsersIcon },
        { id: 'billing', label: 'Billing & Plan', icon: CreditCardIcon },
        // { id: 'security', label: 'Security & Privacy', icon: ShieldCheckIcon },
    ];

    return (
        <nav className="bg-white rounded-lg shadow-md p-4">
            <ul className="space-y-2">
                {navItems.map((item) => (
                    <li key={item.id}>
                        <button
                            onClick={() => setActiveSection(item.id)}
                            className={`flex items-center w-full px-4 py-2 rounded-lg text-left transition-colors duration-200
                               ${activeSection === item.id
                                ? 'bg-indigo-100 text-indigo-700 font-semibold'
                                : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                            }`}
                        >
                            <item.icon className="h-5 w-5 mr-3" />
                            <span>{item.label}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default SettingsSidebar;